import Vue from "vue";

Vue.prototype.$checkRole = function (roles, blockAdmin = false) {
  if (!roles) return false;

  const normalizedRoles = Array.isArray(roles) ? roles : [roles];
  if (!normalizedRoles.length) return false;

  const loggedUser = this && this.$store && this.$store.getters
    ? this.$store.getters.getLoggedUser
    : null;

  if (!loggedUser || !Array.isArray(loggedUser.roles)) return false;

  if (!blockAdmin && loggedUser.roles.includes("admin")) return true;

  return normalizedRoles.some((role) => loggedUser.roles.includes(role));
};